import AdhocReporting from 'components/global/AdhocReporting';

const VCAdhocReporting = () => <AdhocReporting />;

export default VCAdhocReporting;
